//import axiosInstance from '../axiosInstance'
import apiClient from "./axiosInstanceOwner";

// Adding the owner-related function
export const createOwner = async (ownerData) => {
  return await apiClient.post("/v1/owners/", ownerData);
};

export const getAllProfiles = async () => {
  return await apiClient.get(`/v1/owners1/`);
};

export const getProfile = async (id) => {
  return await apiClient.get(`/v1/owners/${id}`);
};
